<template>
  <div class="productDetail" v-loading.fullscreen.lock="loading">
    <div class="list-title">
      <span class='line'></span>
      <span class="big-classify">Recommended for you</span>
      <span class='line'></span>
    </div>
    <div class="product-detail">
      <div class='rich-text' v-html='productDetail'></div>
    </div>

    <div class="footer" v-if='isPhone == null'>
      @2020 EHSY.All rights reserved.
    </div>
    <div class="footer isPhone" v-if='isPhone != null'>
      @2020 EHSY.All rights reserved.
    </div>

  </div>

</template>

<script>
  export default {
    name: "productDetail",
    data (){
      return{
        productDetail:'',
        skuCode: '',
        isPhone: null,
        loading:false,
      }
    },
    created(){
      this.skuCode = this.$route.query.skuCode;
      this.getProductDetail();
      // this.isMobile();
    },
    methods: {
      getProductDetail(){
        let _this = this;
        _this.loading = true;
        let params = {
          // skuCode: 'CWJ813',
          skuCode: this.skuCode,
          cityId: 321,
          token:'',
          // watermark: true
        }
        this.$http.post('pb/product/sku/desc', params,{emulateJSON:true}).then(res => {
          _this.loading = false;
          if(res.body.mark == 0){
            let data = res.body.data.desc;
            data.forEach(function(item){
              console.log(item)
              if(item.cnName == "产品介绍"){
                _this.productDetail = item.description;
              }
            })
          }else{
          }
        });
      },
      // 添加判断方法
      isMobile() {
        this.isPhone = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      }
    }
  }
</script>

<style scoped>
  .productDetail{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .product-detail{
    flex: 1;
    width: 70%;
    margin: 0 auto;
    margin-bottom: 100px;
  }
  .product-detail .rich-text{
    width: 100%;
  }
  .product-detail .rich-text img{
    width: 100%!important;
  }
  .productDetail .list-title {
    margin: 70px 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .productDetail .list-title .line{
    width: 100px;
    height: 1px;
    background: #b7b7b7;
  }
  .productDetail .list-title .big-classify{
    font-size: 1.6rem;
    margin: 0 30px;
    font-weight: bold;
  }
  .footer{
    width: 100%;
    height: 2.5rem;
    line-height: 2.5rem;
    background: #e8e8e8;
    text-align: center;
    font-size: 0.85rem;
    /*position: fixed;*/
    /*bottom:0;*/
  }
  /*.footer.isPhone{*/
    /*height: 3rem;*/
    /*line-height: 3rem;*/
    /*background: #e8e8e8;*/
    /*text-align: center;*/
    /*font-size: 1rem;*/
    /*!*position: fixed;*!*/
    /*!*bottom: 0;*!*/
  /*}*/


</style>



// WEBPACK FOOTER //
// src/pages/product/productDetail.vue